// extracted by mini-css-extract-plugin
export default {"mainDiv":"AddProfile_mainDiv__Qvvpj","main":"AddProfile_main__kp9OJ","icon":"AddProfile_icon__fBgtM"};